export const mobileScreen = 600;
export const tabletscreen = 768;
